import React, { useMemo } from 'react';
import classnames from 'classnames';
// import { useIntl } from 'umi';
// import { useBoolean } from 'ahooks';
import { omit } from 'lodash-es';
import {
  Justify,
  // Switch,
  // Text,
  PagingQuery,
} from 'tea-component';
import CardSlot from '@intelligence/components/CardSlot';
import SearchRecent from '@intelligence/components/SearchRecent';
import TablesContent from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/components/Tables/Content';
import DownloadSimple from '@intelligence/components/DownloadSimple';

import type { IBaseProps, IGameType } from '@intelligence/types/common';
import type { RecordItemType } from '@intelligence/components/SearchRecent/type';
import type {
  TableSelectionType,
  TableSelectStatusType,
} from '@intelligence/components/TableComponents/components/TableCheckbox';
import type { SortByItemType } from '@intelligence/components/TableComponents/components/SortBy';
import type {
  IMobileDetailsOverlapRanksFetchParams,
  IMobileDetailsOverlapDownloadParams,
  IMobileDetailsOverlapRank,
  IMobileDetailsOverlapTopRanksMetrics,
} from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Overlap/types';

interface IMobileDetailsOverlapTablesProps extends IBaseProps {
  entityType: IGameType;
  gameId: string;
  gameName: string;
  regionsOptions?: IRegion[] | null;
  pageKey: string;
  pageDownloadExcelKey: string;
  pageLogInfo: any;
  setActiveId: React.Dispatch<React.SetStateAction<string>>;
  tableLoading: boolean;
  tableTotal: number;
  tableSelection: TableSelectionType[];
  tableSelectionAll: TableSelectionType[];
  tableData: IMobileDetailsOverlapRank[];
  fetchParams: IMobileDetailsOverlapRanksFetchParams;
  topRanksMetrics?: IMobileDetailsOverlapTopRanksMetrics;
  handleClearSearch: () => void;
  transTableDataForSearch: (payload: any) => RecordItemType[];
  fetchOverlapRanks: (params: IMobileDetailsOverlapRanksFetchParams) => Promise<any>;
  getTableSearchList: (id: string) => void;
  onTableSortChage: (payload: SortByItemType) => void;
  onTablePagingChange: (payload: PagingQuery) => void;
  onTableCheckGame: (selectList: TableSelectionType[], checkStatus: TableSelectStatusType) => void;
}

const MobileDetailsOverlapTables: React.FC<IMobileDetailsOverlapTablesProps> = (props) => {
  const {
    entityType,
    gameId,
    gameName,
    regionsOptions,
    pageKey,
    pageDownloadExcelKey,
    pageLogInfo,
    setActiveId,
    tableLoading,
    tableTotal,
    tableSelection,
    tableSelectionAll,
    tableData,
    fetchParams,
    topRanksMetrics,
    handleClearSearch,
    transTableDataForSearch,
    fetchOverlapRanks,
    getTableSearchList,
    onTableSortChage,
    onTablePagingChange,
    onTableCheckGame,
    style,
    className,
  } = props;

  // const { formatMessage } = useIntl();

  // const [isHeatMap, { set: setIsHeatMap }] = useBoolean(false);
  const isHeatMap = false;

  const downloadParams = useMemo<IMobileDetailsOverlapDownloadParams>(() => {
    const fetchParamsTmp = omit(fetchParams || {}, [
      'order_source',
      'order_metric',
      'order',
      'page',
      'page_size',
      'ratio_type',
      'search_by_name',
      'search_by_ids',
    ]);

    return {
      ...fetchParamsTmp,
      unified_name: gameName,
      game_ids: gameId ? [gameId] : [],
      regionOptions: regionsOptions || [],
      ratio_show: 1,
      // 下载excel文件
      file_format: 0,
      // 基础文件名，格式为:游戏名_页签名，后端接口里会拼接上 时间范围
      // new_style_donwload_file_name: `${gameName || 'GameName'}_Cross Mobile Usage`,
      new_style_donwload_file_name: 'Cross Mobile Usage',
    };
  }, [gameId, gameName, fetchParams, regionsOptions]);

  return (
    <div style={style} className={classnames('', className)}>
      <Justify
        className="dbi-card-justify"
        // REMARK: 这里仅隐藏入口，逻辑代码先保留，以免后续有需要开放功能入口
        // left={
        //   <Switch className="dbi-common-switcher" value={isHeatMap} onChange={setIsHeatMap}>
        //     <Text>{formatMessage({ id: 'dbi_compare_heat_map' })}</Text>
        //   </Switch>
        // }
        right={
          <>
            <SearchRecent
              searchType={pageKey}
              pageLogInfo={pageLogInfo}
              fetchParams={fetchParams}
              initSearchInput={!(fetchParams?.search_by_ids?.length > 0)}
              searchListApi={fetchOverlapRanks}
              transTableDataForSearch={transTableDataForSearch}
              handleClear={handleClearSearch}
              getTableResultList={getTableSearchList}
            />
            <DownloadSimple
              disabled={tableLoading}
              pageDownloadExcelKey={pageDownloadExcelKey}
              downloadKey="mobileOverlapDetails"
              downLoadParams={downloadParams}
            />
          </>
        }
      />
      <CardSlot>
        <TablesContent
          entityType={entityType}
          records={tableData}
          loading={tableLoading}
          tableTotal={tableTotal}
          tableSelection={tableSelection}
          tableSelectionAll={tableSelectionAll}
          pageSortAttr={{
            // 排序指标的数据源
            currentOrderSource: fetchParams?.order_source,
            // 排序指标
            currentSortMetric: fetchParams?.order_metric,
            // 排序方式 asc、desc
            currentSortValue: fetchParams?.order,
            // 排序模式，正常数值、环比
            currentRatioType: fetchParams?.ratio_type,
            tablePageIndex: fetchParams?.page,
            tablePageSize: fetchParams?.page_size,
          }}
          isHeatMap={isHeatMap}
          genreSource={fetchParams?.genre_source}
          topRanksMetrics={topRanksMetrics}
          setActiveId={setActiveId}
          onTableSortChage={onTableSortChage}
          onTablePagingChange={onTablePagingChange}
          onTableCheckGame={onTableCheckGame}
        />
      </CardSlot>
    </div>
  );
};

export default React.memo(MobileDetailsOverlapTables);
